import { getRbacAccessToken } from "@risalabs_frontend_org/auth-wrapper";

/**
 * Return the token to send as ``Authorization: Bearer <token>`` on API calls.
 *
 * Under unified-auth this resolves to the RBAC user JWT minted at login (scoped
 * to the active facility), replacing the retired ``risa_front_end_user``
 * service credential. Kept as ``getBearerToken`` so existing call sites work
 * unchanged.
 *
 * @returns The RBAC access token, or ``null`` before login / when unavailable.
 */
export async function getBearerToken(): Promise<string | null> {
  return getRbacAccessToken();
}

/**
 * Backwards-compatible no-op. The RBAC token lifecycle is owned by auth-wrapper
 * and cleared on logout; there is no separate bearer cache to clear here.
 */
export function clearBearerToken(): void {
  // Intentionally empty — retained for API compatibility.
}
